import { Link, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { api } from '../lib/api'
import { saveUser, type User } from '../lib/auth'
import { useI18n } from '../lib/i18n'

export default function Login({ onLogin }: { onLogin: (u: User) => void }) {
  const { t } = useI18n()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [err, setErr] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)
  const nav = useNavigate()

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setErr(null)
    setBusy(true)
    try {
      const { user } = await api.post<{ user: User }>('/api/auth/login', { email, password })
      saveUser(user)
      onLogin(user)
      nav(user.role === 'admin' ? '/admin' : '/dashboard')
    } catch (e: unknown) {
      setErr(e instanceof Error ? e.message : t('Login failed'))
    } finally {
      setBusy(false)
    }
  }

  return (
    <section className="section max-w-md py-16">
      <h1 className="text-3xl font-bold text-white mb-2">{t('Welcome back')}</h1>
      <p className="text-ink-500 mb-8">{t('Sign in to see your leads and commissions.')}</p>
      <form onSubmit={submit} className="space-y-4">
        <label className="block">
          <span className="label">{t('Email')}</span>
          <input required type="email" className="input" value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label className="block">
          <span className="label">{t('Password')}</span>
          <input required type="password" className="input" value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        {err && <div className="rounded-xl border border-red-500/30 bg-red-500/10 text-red-400 text-sm p-3">{err}</div>}
        <button type="submit" disabled={busy} className="btn-primary w-full">
          {busy ? t('Signing in…') : t('Sign in')}
        </button>
      </form>
      <p className="text-sm text-ink-500 mt-6 text-center">
        {t('No account?')} <Link to="/signup" className="text-brand-500 hover:underline">{t('Join as partner')}</Link>
      </p>
    </section>
  )
}
